import React, { useState, useEffect } from 'react';
import { Auth } from 'aws-amplify';
import { useSelector } from 'react-redux';
import { ORGANIZATION_REGION_FORM_UPDATE_URL } from '../../../../../constants';
import {
  postStopApi,
  setStopApi,
} from '../../../../../services/StopApi/StopApi';
import RegionForm from './RegionForm/RegionForm';
import {
  getSaveCancel,
  getFormSuccess,
  getCancelPopup,
} from '../../../../common/commonUtils/commonUtils';

const Region = (props) => {
  const { control, defaultValue, register, useFunction } = props;
  const { handleSubmit } = useFunction;

  const [user, setUser] = useState(null);
  const [formSuccess, setFormSuccess] = useState(false);
  const [cancelPopUp, setCancelPopUp] = useState(false);
  const [isNewRegionForm, setIsNewRegionForm] = useState(false);

  const organizationForm = useSelector((state) => state.organizationForm);
  const {
    newOrganizationForm,
    orgId,
    orgKey,
    organizationName,
    alternateName,
    accountingContactId,
    facilityCoordinatorContactId,
    parentOrganizationId,
    administrativeContactId,
    invoiceVerificationContactId,
    orgCity,
    wCare,
    parole,
    prison,
    other,
    cbp,
    sap,
    stop,
    vendor,
    inactive,
    orgDateCreate,
    orgDateEdit,
    orgCreatedById,
    orgEditedById,
  } = organizationForm;

  const organizationRegionForm = useSelector(
    (state) => state.organizationRegionForm
  );
  const { region } = organizationRegionForm;

  const organizationReferenceData = useSelector(
    (state) => state.organizationReferenceData
  );
  const { cityList } = organizationReferenceData;

  useEffect(() => {
    getUser().then((userData) => setUser(userData));
  }, [user?.signInUserSession.accessToken.jwtToken]);

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => console.log('Not signed in'));
  };

  const getOrgCityName = () => {
    const getOrgCity = cityList.find((item) => item.id === orgCity);
    return getOrgCity.id;
  };

  const onSubmit = () => {
    const url = `${ORGANIZATION_REGION_FORM_UPDATE_URL}`;
    const authorization = user?.signInUserSession.accessToken.jwtToken;
    const payload = {
      orgId: newOrganizationForm ? 0 : orgId,
      orgKey: orgKey,
      organizationName: organizationName,
      alternateName: alternateName,
      accountingContactId: accountingContactId ? accountingContactId : null,
      facilityCoordinatorContactId: facilityCoordinatorContactId
        ? facilityCoordinatorContactId
        : null,
      city: orgCity ? getOrgCityName() : null,
      parentOrganizationId: parentOrganizationId ? parentOrganizationId : null,
      administrativeContactId: administrativeContactId
        ? administrativeContactId
        : null,
      invoiceVerificationContactId: invoiceVerificationContactId
        ? invoiceVerificationContactId
        : null,
      wCare: wCare,
      parole: parole,
      prison: prison,
      other: other,
      cbp: cbp,
      sap: sap,
      stop: stop,
      vendor: vendor,
      inactive: inactive,
      orgDateCreate: orgDateCreate,
      orgDateEdit: orgDateEdit,
      orgCreatedById: orgCreatedById ? orgCreatedById : null,
      orgEditedById: orgEditedById ? orgEditedById : null,
      region: region ? region : null,
    };
    if (newOrganizationForm) {
      postStopApi({ url, payload, authorization }).then((response) => {
        if (response.succeeded === true) {
          setFormSuccess(true);
          setIsNewRegionForm(true);
        }
      }).catch((e) => alert(e));
    } else {
      setStopApi({ url, payload, authorization }).then((response) => {
        if (response.succeeded === true) {
          setFormSuccess(true);
          setIsNewRegionForm(false);
        }
      }).catch((e) => alert(e));
    }
  };

  const handleCancelPopUp = () => {
    setCancelPopUp(true);
  };

  return (
    <>
      <RegionForm
        control={control}
        defaultValue={defaultValue}
        register={register}
      />
      {getSaveCancel(handleCancelPopUp, null, handleSubmit(onSubmit))}
      {getFormSuccess(formSuccess, setFormSuccess, isNewRegionForm)}
      {getCancelPopup(cancelPopUp, setCancelPopUp)}
    </>
  );
};

export default Region;
